import appLoan from "../../views/appSettings/loan.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("loan", {
    url: "loan/:id",
    parent: "app",
    views: {
      view: {
        template: appLoan,
      },
    },
    reloadOnSearch: false,
    data: { title: "Loan" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/loan/loan.urls.js